import { createApp } from 'vue';
import MessageToSentry from '@component_path/lib/messageToSentry';
import TimeRequiredExplanationModal from '@component_path/pages/pc/positions/show/time_required_explanation_modal';
import OneClickInquiryModal from '@component_path/pages/pc/positions/show/one_click_inquiry_modal';
import DetailContactButtonArea from '@component_path/pages/pc/positions/show/detail_contact_button_area';
import ContactButton from '@component_path/pages/pc/positions/show/contact_button';
import store from '@component_path/pages/pc/positions/show/store';

import _floatingFooter from '@component_path/pages/pc/positions/floating_footer';
import moveSmoothly from '@component_path/lib/moveSmoothly';
import pcrContents from '@component_path/pages/pc/positions/show/module/pcr_contents';

export default (formComponent, birth_years) => {
  Object.keys(pcrContents).map(keyName => {
    const pcrContent = pcrContents[keyName];
    const contactBtnEl = document.getElementById(pcrContent);
    if (contactBtnEl !== null) {
      const contactBtnProps = JSON.parse(contactBtnEl.getAttribute('data'));

      const pcrContentApp = createApp(ContactButton, {
        appealingText: contactBtnProps.appealing_text,
        pcrContent: pcrContent,
        additionalClassName: contactBtnProps.additional_class_name,
        atlasIconName: contactBtnProps.atlas_icon_name
      });

      pcrContentApp.config.errorHandler = MessageToSentry.fromVueInstance;

      pcrContentApp.use(store).mount(`#${pcrContent}`);
    }
  });
  const oneClickInquiryNode = document.getElementById(
    'one-click-inquiry-form-initial-data'
  );
  // 通常の問い合わせフォームの一部のコンポーネントに欠けている入力値を初期値で補完する処理がある
  // ワンクリック問い合わせに、欠けている入力値が補完されることを防ぐために、通常問い合わせフォームより先に宣言する
  const oneClickInquiryEnabled =
    oneClickInquiryNode !== null && typeof oneClickInquiryNode != 'undefined';
  if (oneClickInquiryEnabled) {
    const oneClickInquiryProps = JSON.parse(
      oneClickInquiryNode.getAttribute('data')
    );

    const oneClickInquiryApp = createApp(
      OneClickInquiryModal,
      oneClickInquiryProps
    );

    oneClickInquiryApp.config.errorHandler = MessageToSentry.fromVueInstance;

    oneClickInquiryApp.use(store).mount('#one-click-inquiry-form');
  }

  if (document.getElementById('detail-contact-button-area') !== null) {
    const detailContactApp = createApp(DetailContactButtonArea, {
      oneClickInquiryEnabled
    });

    detailContactApp.config.errorHandler = MessageToSentry.fromVueInstance;

    detailContactApp.use(store).mount('#detail-contact-button-area');
  }

  const timeRequiredLinkApp = createApp(TimeRequiredExplanationModal);

  timeRequiredLinkApp.config.errorHandler = MessageToSentry.fromVueInstance;

  timeRequiredLinkApp.mount('#time-required-link');

  // 「◯人がこの求人を見ています」という表示がある時、atlasフッターを高くしないとフッターのコンテンツが隠れてしまうので
  // 「◯人がこの求人を見ています」という表示がある時はatlasフッターを高くする
  const numberOfPositionViewerCaption = document.querySelector(
    '.m3p-joblist__howmany-tx'
  );
  const atlasFooter = document.querySelector('.atlas-footer');
  // 画面表示時にatlasフッターの読み込みが完了していないため、atlasフッター読み込みした後にスタイル指定の処理を行うようにする
  if (atlasFooter !== null) {
    atlasFooter.style.height = numberOfPositionViewerCaption
      ? '140px'
      : '110px';
  }

  // 「◯人がこの求人を見ています」という表示がある時、「topに戻る」ボタンの位置が中途半端になってしまう
  // 「◯人がこの求人を見ています」という表示がある時は「topに戻る」ボタンの表示位置を高くする
  const topBtn = document.querySelector('.m3p-pagetop');
  const topBtnBottomPosition = numberOfPositionViewerCaption ? 110 : 80;
  topBtn.style.bottom = `${topBtnBottomPosition}px`;
  window.addEventListener('scroll', () => {
    if (window.pageYOffset > 400) {
      topBtn.style.bottom = `${topBtnBottomPosition}px`;
    } else {
      topBtn.style.bottom = `-${topBtnBottomPosition}px`;
    }
  });

  const node = document.getElementById('inquiry-form-initial-data');
  const props = JSON.parse(node.getAttribute('data'));
  // 生まれ年のみサーバサイドではなくクライアントで実装済みのライブラリを流用する
  props['master_data'] = Object.assign(props['master_data'], { birth_years });

  const app = createApp(formComponent, props);

  app.config.errorHandler = MessageToSentry.fromVueInstance;

  app.use(store).mount('#inquiry-form-initial-data');

  moveSmoothly('a[href^="#inquiry-form"]', '#inquiry-form');
};
